export function createDefer() {
    const rv = {
        promise: null,
        resolve: () => { },
        reject: () => { },
        isResolved: false,
        then(cb) {
            const { promise } = this;
            return promise.then(cb);
        }
    };
    rv.promise = new Promise((resolve, reject) => {
        rv.resolve = (value) => {
            rv.isResolved = true;
            resolve(value);
        };
        rv.reject = (err) => {
            rv.isResolved = true;
            reject(err);
        };
    });
    return rv;
}
